import Dexie, { Table } from "dexie";
import { FollowJwtRabbitStatus } from "@hub/models/challenges/matrix";
import { PuzzlePieceType } from "@hub/models/challenges/puzzle";

export const JWT_GAME_DB_NAME = "jwtGameDb";

export interface RabbitModel {
  id?: number;
  piece: string;
  order: number;
  hints: string[];
  type: PuzzlePieceType;
}

export interface GameModel {
  id?: string;
  status: FollowJwtRabbitStatus;
  siteRabbitsNotification: boolean;
  eventRabbitsFoundNotification: boolean;
  findJwtNotification: boolean;
  jwt: string;
}

export class MySubClassedDexie extends Dexie {
  rabbits!: Table<RabbitModel>;
  game!: Table<GameModel>;

  constructor() {
    super(JWT_GAME_DB_NAME);
    this.version(1).stores({
      rabbits: "++id, piece, order",
      game: "id",
    });
  }
}

export const jwtGameDb = new MySubClassedDexie();
